<template>
	<ext-dialog
		v-model="value"
		:title="$t('proforma_options')"
		:primaryButtonText="$t('confirm')"
		dialogType="small"
		@primaryButtonAction="onConfirm"
		@closed="onCancel"
	>
		<template #body>
			<v-form ref="form" v-model="valid" lazy-validation>
				<v-row>
					<v-col cols="12">
						<v-text-field
							v-model="options.no"
							:label="$t('proforma_number')"
							prepend-icon="icon-document"
							:rules="[(v) => !!v || $t('$validation.required', { item: $t('proforma_number') })]"
						/>
					</v-col>
					<v-col cols="12">
						<shipping-term-select
							v-model="options.shippingTerm.code"
							:label="$t('shipping_term')"
							prepend-icon="icon-truck"
							:rules="[(v) => !!v || $t('$validation.required', { item: $t('shipping_term') })]"
							clearable
							:eager="true"
							@change="onTermChange"
						/>
					</v-col>
				</v-row>
			</v-form>
		</template>
	</ext-dialog>
</template>

<script>
import ExtDialog from "./ExtDialog.vue";
import ShippingTermSelect from "../../controls/ShippingTermSelect.vue";

export default {
	name: "ProformaOptionsDialog",
	components: { ExtDialog, ShippingTermSelect },
	props: ["value"],
	data() {
		return {
			valid: false,
			options: {
				no: "",
				shippingTerm: {
					code: "",
					name: "",
				},
			},
		};
	},
	watch: {
		// whenever it's opened we auto‐generate a random number
		value(val) {
			if (val) {
				this.options.no = `PF-${Math.floor(100000 + Math.random() * 900000)}`;
				this.options.shippingTerm = { code: "", name: "" };
				this.$nextTick(() => (this.valid = false));
			}
		},
	},
	methods: {
		onCancel() {
			this.$emit("input", false);
		},
		onTermChange(term) {
			// shipping‐term‐select emits the full term object
			this.options.shippingTerm.name = term?.name || "";
		},
		onConfirm() {
			if (this.$refs.form.validate()) {
				this.$emit("confirm", { ...this.options });
				this.$emit("input", false);
			}
		},
	},
};
</script>
